const getState = state => state.PupilStore

const getPupil = state => getState(state).pupil

const getFetchRequest = state => getState(state).fetchRequest

export { getPupil, getFetchRequest }
